import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { PaginationResult } from '../core/pagination';
import {
  AddTokensRequest,
  CreateBusinessOwnerRequest,
  SubscriptionType,
  BusinessOwner,
} from '../models';

@Injectable({ providedIn: 'root' })
export class BusinessOwnersApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/users`;

  getBusinessOwners(options?: {
    name?: string;
    subscriptions?: SubscriptionType[];
    skip?: number;
    take?: number;
  }) {
    let params = new HttpParams();

    if (options?.name) {
      params = params.append('name', options.name);
    }

    if (options?.subscriptions && options?.subscriptions.length === 1) {
      params = params.append('subscriptionType', options.subscriptions[0]);
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.httpClient.get<PaginationResult<BusinessOwner>>(`${this.baseUrl}`, {
      params,
    });
  }

  createUser(dto: CreateBusinessOwnerRequest) {
    return this.httpClient.post<void>(`${this.baseUrl}`, dto).pipe(
      catchError((error) => {
        if (error.error === 'User with this email already exists') {
          return throwError(
            () => "L'indirizzo email specificato è già in uso.",
          );
        }
        return throwError(
          () =>
            "Si è verificato un errore inaspettato. Riprova più tardi o contatta l'assistenza tecnica.",
        );
      }),
    );
  }

  addTokens(userId: string, dto: AddTokensRequest) {
    return this.httpClient
      .post<void>(`${this.baseUrl}/${userId}/tokens`, dto)
      .pipe(
        catchError(() =>
          throwError(
            () =>
              "Si è verificato un errore inaspettato. Riprova più tardi o contatta l'assistenza tecnica.",
          ),
        ),
      );
  }
}
